module.exports = __webpack_public_path__ + "img/insight19.7f53a7f7.png";